'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    'en-us': {
        empty: 'No data',
        ok: 'Ok',
        reset: 'Reset'
    },
    'zh-cn': {
        empty: '没有数据',
        ok: '确认',
        reset: '重置'
    },
    'zh-tw': {
        empty: '沒有數據',
        ok: '確認',
        reset: '重置'
    }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/@alife/next/lib/_components/@alife/next-table/lib/locale/index.js
// module id = 453
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11